import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { productsData } from '../data';

const Products = () => {
  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Herramientas de marca
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Desglose de inversión mensual
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        sx={{ mb: 4, maxWidth: 640, mx: 'auto' }}
      >
        Plan de visibilidad total: video, audio, pantalla y redes en un solo paquete.
      </Typography>
      <Grid container spacing={3}>
        {productsData.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card
              elevation={2}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 60}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="overline" color="primary" fontWeight={600} display="block" gutterBottom>
                  {item.product}
                </Typography>
                <Typography variant="h6" gutterBottom fontWeight={700}>
                  {item.title}
                </Typography>
                <Typography variant="h5" color="secondary.dark" fontWeight={800} sx={{ my: 1 }}>
                  {item.investment}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  Alcance:
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.5, mt: 0.5 }}>
                  {item.impacts.map((impact, j) => (
                    <Typography
                      key={j}
                      component="li"
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 0.5, lineHeight: 1.65 }}
                    >
                      {impact}
                    </Typography>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Products;
